<footer class="ngdpFooter">
  Helpdesk: 89 87 21 37 -
  <a href="mailto:helpdesk@serviceplatformen.dk"
    >helpdesk@serviceplatformen.dk</a
  >
  - KOMBIT A/S, Halfdansgade 8, 2300 København S - CVR-nr.: 19435075 - EAN-nr.
  57900001969370
</footer>
